module.exports = __webpack_public_path__ + "static/media/game-board.9847c0e8.svg";